import type {AuthState} from './types'
import {type AuthAction, AuthActionType} from '../actions'

export const initialAuthState: AuthState = {
  pending: false,
  error: null,
  token: null
}

export function authReducer(state: AuthState = initialAuthState, action: AuthAction): AuthState {
  switch (action.type) {
    case AuthActionType.AUTH_START:
      return {...state, pending: true, error: null}
    case AuthActionType.AUTH_SUCCESS:
      return {...state, pending: false, error: null, token: action.payload.token}
    case AuthActionType.AUTH_FAILURE:
      return {...state, pending: false, error: action.payload.error, token: null}
    case AuthActionType.AUTH_CLEAR:
      return {...state, ...initialAuthState}
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- this needs to be here
    default:
      return state
  }

}
